/**
 * Removes the protocol (http:// or https://) and "www." from a URL, preserving other subdomains.
 *
 * @param {string|null|undefined} value - The URL to be cleaned.
 * @return {string|null|undefined} The cleaned URL without the protocol and "www.".
 */
export function cleanUrl(value) {
  if (value === null || value === undefined) {
    return value;
  }
  return value.replace(/^(https?:\/\/)?(www\.)?/, '');
}